interface Props {
  status?: string;
  children?: React.ReactNode;
}

export const DashboardItemChart: React.FC<Props> = ({ status, children }) => {
  return (
    <div className="flex space-x-1.5 items-center">
      <div className={`w-3 h-3 bg-status-${status}`} />
      <div className="font-semibold text-gray-500">{children}</div>
    </div>
  );
};
